import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Swiper, SwiperSlide} from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import {Navigation} from 'swiper/modules'

import PDComponent from '../../pd-component'

export const PromoQuickCategory = ({
    regions,
    titleText,
    titleTextColor,
    titleFontFamily,
    titleTag,
    borderColor
}) => {
    const promoQuickCategoryCards = regions.reduce(
        (acc, region) =>
            acc + (region?.components?.filter((component) => component?.data?.linkUrl) || 0),
        0
    )
    if (!promoQuickCategoryCards) {
        return null
    }

    return (
        <Box
            display="inline-flex"
            borderTop="0.25px solid"
            marginLeft={{base: '15px', lg: '60px'}}
            marginRight={{base: '0', lg: '60px'}}
            marginY="15px"
            sx={{
                borderImage: `linear-gradient(to right, ${borderColor} 50%, white 80%) 1`
            }}
            width={{base: '100%', md: 'auto'}}
            minWidth="0"
            maxWidth="100%"
        >
            <Box
                display="flex"
                fontSize="18px"
                justify="center"
                alignItems="center"
                color={titleTextColor}
                fontFamily={titleFontFamily}
                paddingY="10px"
            >
                {titleText && (
                    <Text noOfLines="1" as={titleTag} marginRight="15px">
                        {titleText}
                    </Text>
                )}
            </Box>
            <Box
                width={{
                    base: titleText ? '60%' : '100vw',
                    lg: 'auto'
                }}
                maxWidth="100%"
                margin="0"
                marginBottom={{base: '-30px', lg: '0'}}
                sx={{
                    '.swiper': {
                        paddingTop: '10px',
                        paddingBottom: '10px',

                        '&:not(.swiper-initialized)': {
                            paddingRight: {base: '20px', lg: '60px'},

                            '.swiper-wrapper': {
                                display: 'flex',
                                overflowX: 'auto',
                                gap: '10px'
                            }
                        }
                    },
                    '.swiper-wrapper': {
                        alignItems: 'center'
                    },
                    '.swiper-slide': {
                        display: 'flex',
                        width: 'auto'
                    },
                    '.swiper-button-prev, .swiper-button-next': {
                        display: 'none'
                    }
                }}
            >
                <Swiper
                    navigation={true}
                    modules={[Navigation]}
                    slidesPerView={'auto'}
                    spaceBetween={15}
                    slidesPerGroup={1}
                    slidesOffsetAfter={35}
                >
                    {regions?.map((region) =>
                        region?.components?.map((component, index) =>
                            component.data.linkUrl ? (
                                <SwiperSlide key={`${region.id}-${index}`}>
                                    <PDComponent titleText={titleText} component={component} />
                                </SwiperSlide>
                            ) : null
                        )
                    )}
                </Swiper>
            </Box>
        </Box>
    )
}

PromoQuickCategory.propTypes = {
    regions: PropTypes.array,
    titleText: PropTypes.string,
    titleTextColor: PropTypes.string,
    titleFontFamily: PropTypes.string,
    titleTag: PropTypes.string,
    borderColor: PropTypes.string
}

export default PromoQuickCategory
